module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"zipcode":"CEP","street":"Logradouro","neighborhood":"Bairro","city":"Cidade"},"en-US":{"zipcode":"Zip code","street":"Line 1","neighborhood":"Neighborhood","city":"City"}}')
  delete Component.options._Ctor
}
